import { createStyles } from '@material-ui/styles';
import palette from 'theme/palette';

export default () =>
  createStyles({
    container: {
      marginTop: 0,
      marginBottom: 0,
      marginRight: 8,

      '& .MuiIconButton-root': {
        padding: 0,
      },
    },
    datePicker: { color: palette.navAdmin, backgroundColor: palette.navAdmin },
    form: {
      display: 'flex',
      flexWrap: 'wrap',
    },
    textField: {
      marginLeft: 3,
      marginRight: 3,
      width: 200,
    },
  });
